export default __webpack_public_path__ + "static/media/Men_Sizing_Chart-Mobile.e9538321.png";